import React from 'react';

export type RoutingData = {
  logoutParam?: string;
  redirectParam?: string;
  passwordResetTokenParam?: string;
  authTokenParam?: string;
  usernameParam?: string;
};

export const DEFAULT_ROUTING_DATA: RoutingData = {};

type RoutingDataContextValue = {
  routingData: RoutingData;
  setRoutingData: React.Dispatch<React.SetStateAction<RoutingData>>;
};

export const RoutingDataContext = React.createContext<RoutingDataContextValue>({
  routingData: DEFAULT_ROUTING_DATA,
  setRoutingData: () => null,
});
